import { Component, inject, output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HeaderVersamentoOperazioniMassive, HeaderVersamentoOperazioniMassiveForm } from '../models/operazioni-massive.model';

@Component({
  selector: 'app-intestazione-versamenti',
  template: `
    <form [formGroup]="headerForm">
      <div class="advanced-form">
        <div class="grid">

          <div class="col-12 lg:col-6">
            <label class="small-label" for="numeroNota">Numero nota</label>
            <p-inputNumber id="numeroNota" formControlName="numeroNota" mode="decimal" [useGrouping]="false" [style]="{'width': '420px'}"/>
          </div>

          <div class="col-12 lg:col-6">
            <label class="small-label" for="date">Data versamento</label>
            <p-calendar formControlName="date" inputId="date"
              dateFormat="dd/mm/yy" selectionMode="single" [showIcon]="true" [inputStyle]="{'width': '420px'}">
            </p-calendar>
          </div>

          <div class="col-12">
            <label class="small-label" for="note">Nota per registro</label>
            <textarea pInputTextarea rows="10" cols="80" formControlName="note" id="note" class="min-h-80px border-round-md border-400  hover:border-primary-600 hover:shadow-3"></textarea>
         </div>
        </div>
      </div>
    </form>
  `,
  styles: `
    .text-area-dialog { min-height: 40px; width: 100%; }
  `
})
export class IntestazioneVersamentiComponent {

  onCompiled = output<HeaderVersamentoOperazioniMassive | undefined>();

  private readonly fb = inject(FormBuilder);

  public headerForm: FormGroup<HeaderVersamentoOperazioniMassiveForm>;

  constructor() {
    this.headerForm = this.fb.group<HeaderVersamentoOperazioniMassiveForm>({
      numeroNota: new FormControl(null, [Validators.required]),
      date: new FormControl(null, [Validators.required]),
      note: new FormControl('', [Validators.required])
    });

    this.headerForm.valueChanges.subscribe(d => {

      let value: HeaderVersamentoOperazioniMassive | undefined = undefined;

      if (this.headerForm.valid) {
        if (this.headerForm.value.numeroNota && this.headerForm.value.date && this.headerForm.value.note) {
          value = {
            numeroNota: this.headerForm.value.numeroNota,
            date: this.headerForm.value.date,
            note: this.headerForm.value.note
          };
        }
      }

      this.onCompiled.emit(value);
    });
  }
}
